import * as React from "react"
import {useEffect} from "react"
import {Grid} from "@mui/material";

import {HOME_ROUTES, REPRICING_ROUTES} from "@constants"
import PageWrapper from "Pages/@PageWrapper"
import {clearRepricingFormSignals} from "../@signals";
import RepricingCrudForm from "./Form";
import RepricingChecker from "./Checker";


export default function RepricingCrudPage() {

	useEffect(() => {
		return clearRepricingFormSignals
	}, [])

	return <PageWrapper
		head={`DIP Insight | ${REPRICING_ROUTES.FORM_TITLE}`}
		title={REPRICING_ROUTES.FORM_TITLE}
		subtitle={REPRICING_ROUTES.FORM_SUBTITLE}
		actions={null}
	>
		<Grid container spacing={2}>
			<Grid item xs={12}>
				<RepricingCrudForm />
			</Grid>
			<Grid item xs={12}>
				<RepricingChecker />
			</Grid>
		</Grid>
	</PageWrapper>
}